import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'

const CaseStudies = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="relative bg-gray-900">
            <div className="absolute inset-0">
              <img
                className="w-full h-full object-cover opacity-30"
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                alt="Case Studies"
              />
            </div>
            <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
              <div className="text-center">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                  <span className="block">Our Success Stories</span>
                </h1>
                <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-100">
                  See how we've helped businesses achieve remarkable results through strategic digital solutions.
                </p>
              </div>
            </div>
          </div>
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-12">
              {/* Case Study 1 */}
              <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                  <div className="relative h-64 lg:h-full">
                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                      alt="TechStart dashboard"
                    />
                  </div>
                  <div className="p-8 lg:p-12">
                    <div className="flex items-center">
                      <span className="inline-block px-3 py-1 text-sm font-semibold text-primary bg-primary-100 rounded-full">
                        SaaS Development
                      </span>
                      <span className="ml-2 text-sm text-gray-500">6 Month Engagement</span>
                    </div>
                    <h2 className="mt-4 text-2xl font-bold text-gray-900">
                      TechStart HR Platform: 300% User Growth
                    </h2>
                    <p className="mt-4 text-gray-600">
                      Developed a custom HR SaaS solution that helped TechStart streamline their onboarding process and scale their operations.
                    </p>
                    <div className="mt-6 grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-3xl font-bold text-primary">300%</p>
                        <p className="text-sm text-gray-500">Increase in active users</p>
                      </div>
                      <div>
                        <p className="text-3xl font-bold text-primary">75%</p>
                        <p className="text-sm text-gray-500">Reduction in onboarding time</p>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Link
                        to="/case-studies/techstart"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Read Full Case Study
                        <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Case Study 2 */}
              <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                  <div className="relative h-64 lg:h-full lg:order-last">
                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src="https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                      alt="RetailPlus e-commerce"
                    />
                  </div>
                  <div className="p-8 lg:p-12">
                    <div className="flex items-center">
                      <span className="inline-block px-3 py-1 text-sm font-semibold text-primary bg-primary-100 rounded-full">
                        E-commerce Marketing
                      </span>
                      <span className="ml-2 text-sm text-gray-500">12 Month Campaign</span>
                    </div>
                    <h2 className="mt-4 text-2xl font-bold text-gray-900">
                      RetailPlus: 220% Revenue Growth
                    </h2>
                    <p className="mt-4 text-gray-600">
                      Implemented a comprehensive digital marketing strategy that transformed RetailPlus from a local retailer to a national e-commerce brand.
                    </p>
                    <div className="mt-6 grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-3xl font-bold text-primary">220%</p>
                        <p className="text-sm text-gray-500">Revenue increase</p>
                      </div>
                      <div>
                        <p className="text-3xl font-bold text-primary">5.8x</p>
                        <p className="text-sm text-gray-500">Return on ad spend</p>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Link
                        to="/case-studies/retailplus"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Read Full Case Study
                        <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Case Study 3 */}
              <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                  <div className="relative h-64 lg:h-full">
                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                      alt="Global Finance Corp office"
                    />
                  </div>
                  <div className="p-8 lg:p-12">
                    <div className="flex items-center">
                      <span className="inline-block px-3 py-1 text-sm font-semibold text-primary bg-primary-100 rounded-full">
                        B2B Lead Generation
                      </span>
                      <span className="ml-2 text-sm text-gray-500">8 Month Campaign</span>
                    </div>
                    <h2 className="mt-4 text-2xl font-bold text-gray-900">
                      Global Finance Corp: 400% More Qualified Leads
                    </h2>
                    <p className="mt-4 text-gray-600">
                      Designed and executed a targeted LinkedIn advertising campaign that delivered high-quality leads at 40% below industry average cost.
                    </p>
                    <div className="mt-6 grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-3xl font-bold text-primary">400%</p>
                        <p className="text-sm text-gray-500">More qualified leads</p>
                      </div>
                      <div>
                        <p className="text-3xl font-bold text-primary">40%</p>
                        <p className="text-sm text-gray-500">Lower cost per lead</p>
                      </div>
                    </div>
                    <div className="mt-8">
                      <Link
                        to="/case-studies/global-finance"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
                      >
                        Read Full Case Study
                        <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 text-center">
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700"
              >
                Ready to see results like these?
                <svg className="ml-3 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default CaseStudies